<template>
  <div v-if="onlyShowPopup==null" @click="showSelectDate" style="display: flex;flex-direction: row" :style="style">
    <div class="tHDatePickerParentDiv">
      <div class="leftTextStyle" :style="{
            padding: smallType?'4px 4px':'7px 8px',
            backgroundColor:hcf.getMainColor()+'1a',
        }">
        <div :style="hcf.getTextStyle({
        color:'main',
    })">
          {{ selectStartDate }}
        </div>
        <div :style="hcf.getTextStyle({
        marginLeft:smallType?1:5,marginRight:smallType?1:5,color:'main',
    })">
          至
        </div>
        <div :style="hcf.getTextStyle({
        color:'main',
    })">
          {{ selectEndDate }}
        </div>
      </div>
    </div>
    <div class="rightTextStyle"  :style="{
            padding: smallType?'4px 4px':'7px 8px',
        }">
      <div :style="hcf.getTextStyle({
        color:'white',addSize:smallType?0:1,
    })">
        {{ showRightDurDaysText }}
      </div>
    </div>
  </div>
  <van-calendar v-if="onlySelectUI == null" ref="calRef" v-model:show="showSelectModal" type="range"
                :min-date="minDate" :max-date="maxDate" :default-date="defaultRange"
                teleport="body" safe-area-inset-bottom
  >
    <template #footer>
      <div class="hdpShortcutRow" :style="{ backgroundColor: hcf.getMainColor()+'14' }">
        <div v-for="opt in quickOptions" :key="opt.key" class="hdpShortcut"
             :style="{ color: hcf.getMainColor() }" @click="onQuick(opt)">
          {{ opt.label }}
        </div>
      </div>
      <div class="hdpBtnRow">
        <div class="hdpCancel" @click="onCancel">取消</div>
        <div class="hdpOk" :style="{ color: hcf.getMainColor() }" @click="onConfirmClick">确认</div>
      </div>
    </template>
  </van-calendar>
</template>


<script setup>
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";

  const props = defineProps(["style","change","onlyShowPopup","onlySelectUI","smallType","tag"]);
  onMounted(()=>{
    if(props.onlyShowPopup){
        emitter.on("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"",()=>{
          showSelectModal.value = true;
        });
    }
    if(props.onlySelectUI){
      emitter.on("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK"+props.tag??"",(values)=>{
        onConfirm(values);
      });

    }
  });
  onUnmounted(()=>{
    if(props.onlyShowPopup){
      emitter.off("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"");
    }
    if(props.onlySelectUI){
      emitter.off("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK"+props.tag??"");
    }
  });

  //默认最大选择的日期范围 30天
  const minDate = new Date(Date.now() - 86400 * 1000 * 29);
  const maxDate = new Date(Date.now());

  const calRef = ref(null);

  //日历默认高亮的日期范围(默认近3天), 快捷项/确认后同步, 供下次打开回显
  const defaultRange = ref([new Date(Date.now() - 86400 * 1000 * 2), new Date(Date.now())]);

  //快捷选项: days 为起始日相对今天往回的天数(与 flutter selectNearDay 一致)
  const quickOptions = [
    {key: "today", label: "今天", days: 0},
    {key: "yesterday", label: "昨天", days: 1},
    {key: "d3", label: "近3天", days: 2},
    {key: "d7", label: "近7天", days: 6},
    {key: "d15", label: "近15天", days: 14},
    {key: "d30", label: "近30天", days: 29},
  ];

  const selectStartDate = ref(hcf.getDateByMillSecs(Date.now() / 1000 - 86400 * 2));
  const selectEndDate = ref(hcf.getDateByMillSecs(Date.now() / 1000));

  const showSelectModal = ref(false);

  const showRightDurDaysText = ref("近3天");

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  //右侧时长徽标文案(与 flutter 一致): 今天/昨天/近N天/N天
  function getDurText(endDate, days) {
    const today = new Date();
    if (isSameDay(endDate, today)) {
      return days === 1 ? "今天" : `近${days}天`;
    }
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (isSameDay(endDate, yesterday)) {
      return "昨天";
    }
    return `${days}天`;
  }

  //应用一个日期范围: 更新显示/徽标/回显, 并回调外部(或转发事件)
  function applyValues(values, {close = true} = {}) {
    let [start, end] = values;
    if (!start) {
      if (close) showSelectModal.value = false;
      return;
    }
    if (!end) end = start;

    selectStartDate.value = formatDate(start);
    selectEndDate.value = formatDate(end);

    const days = getDateDiffInDays(start, end);
    showRightDurDaysText.value = getDurText(end, days);

    let startSecs = getDayTimestamp(selectStartDate.value);
    let endSecs = getDayTimestamp(selectEndDate.value, false);
    if (endDayIsCurDay()) {
      endSecs = Math.floor(Date.now() / 1000);
    }

    defaultRange.value = [start, end];
    if (close) showSelectModal.value = false;

    if (props.onlyShowPopup) {
      emitter.emit("EVENT_LISTEN_SPECIAL_UPDATE_DATE_PICK" + props.tag ?? "", [start, end]);
    } else {
      props.change(startSecs, endSecs);
    }
  }

  //外部事件(拆分成两个组件时)转发进来的回显, 不涉及本组件弹窗
  const onConfirm = (values) => {
    applyValues(values, {close: false});
  };

  //点击快捷选项: 立即选中并关闭弹窗
  function onQuick(opt) {
    const start = new Date();
    start.setDate(start.getDate() - opt.days);
    start.setHours(0, 0, 0, 0);
    let end;
    if (opt.key === "yesterday") {
      end = new Date(start);
      end.setHours(23, 59, 59, 999);
    } else {
      end = new Date();
    }
    applyValues([start, end]);
  }

  //点击"确认": 读取日历当前选中的范围并应用
  function onConfirmClick() {
    const sel = calRef.value?.getSelectedDate?.() || [];
    applyValues([sel[0], sel[1]]);
  }

  function onCancel() {
    showSelectModal.value = false;
  }

  function showSelectDate() {
    if(props.onlySelectUI){
      emitter.emit("EVENT_LISTEN_SPECIAL_SHOW_DATE_PICK"+props.tag??"");
    }else{
      showSelectModal.value = true;
    }
  }

  function endDayIsCurDay(){
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 清除时间部分，只保留日期
    const endDay = new Date(selectEndDate.value);
    endDay.setHours(0, 0, 0, 0);
    return endDay.getTime() === today.getTime();
  }

  // const startTimestamp = getDayTimestamp('2020-04-02', true)   // 00:00:00 的时间戳
  // const endTimestamp = getDayTimestamp('2020-04-02', false)    // 23:59:59 的时间戳
  function getDayTimestamp(dateStr, isStartOfDay = true) {
    const date = new Date(dateStr)

    if (isStartOfDay) {
      date.setHours(0, 0, 0, 0)
    } else {
      date.setHours(23, 59, 59, 999)
    }

    return Math.floor(date.getTime() / 1000)
  }

  //计算两个时间相差几天
  function getDateDiffInDays(start, end) {
    const diffInMs = end.getTime() - start.getTime();
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1; // +1 表示包含起始日
  }

</script>


<style scoped>
  .leftTextStyle {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border: var(--ct-main-color) 1px solid;display:flex;
  }

  .rightTextStyle {
    display: flex;
    background-color: var(--ct-main-color);
    align-items: center;
    justify-content: center;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .tHDatePickerParentDiv {
    display: inline-flex;
    flex-direction: row;
  }

  /* 快捷选项行: 单行横向平均分布(今天/昨天/近3天/近7天/近15天/近30天) */
  .hdpShortcutRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 12px 4px;
    margin-bottom: 8px;
  }

  .hdpShortcut {
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .hdpShortcut:active {
    opacity: 0.6;
  }

  /* 取消 / 确认 */
  .hdpBtnRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 0 20px 6px;
  }

  .hdpCancel, .hdpOk {
    font-size: 16px;
    line-height: 1;
    padding: 5px 20px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .hdpCancel {
    color: #999;
  }

  .hdpCancel:active, .hdpOk:active {
    opacity: 0.6;
  }

</style>
